// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes in-btn-social-162ceece{0%{left:-110%;top:90%}50%{left:10%;top:-30%}100%{top:-10%;left:-10%}}@keyframes out-btn-social-162ceece{0%{top:-10%;left:-10%}50%{left:10%;top:-30%}100%{left:-110%;top:90%}}.section[data-v-162ceece]{background-color:#fff;padding:4rem 0}@media(min-width: 1200px){.section[data-v-162ceece]{padding:8rem 0}}", ""]);
// Exports
module.exports = exports;
